"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

require("source-map-support/register");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SentryProvider = /*#__PURE__*/function () {
  function SentryProvider(_config, sentryClient) {
    var _this = this;

    _classCallCheck(this, SentryProvider);

    this.sentryClient = void 0;

    this.init = function (config) {
      _this.sentryClient.init(_this.getSentryConfig(config));
    };

    this.log = function (message) {
      _this.sentryClient.captureMessage(message);
    };

    this.logException = function (exception) {
      _this.sentryClient.captureException(exception);
    };

    this.close = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(timeout) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.sentryClient.flush(timeout);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this.sentryClient = sentryClient;
    this.init(_config);
  }

  _createClass(SentryProvider, [{
    key: "getSentryConfig",
    value: function getSentryConfig(config) {
      return {
        dsn: config.url,
        environment: config.environment
      };
    }
  }]);

  return SentryProvider;
}();

exports["default"] = SentryProvider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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